module.exports = __webpack_public_path__ + "static/img/solution-1.a23045d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Main/solution-1.png
// module id = XasC
// module chunks = 10